import { FC, useState } from 'react';
import { useHistory } from 'react-router';
import { useStore } from 'hooks/useRootStore';
import { useQuery, useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { observer } from 'mobx-react-lite';
import { ConfirmActionDialog } from 'components/Dialogs';
import { GridColumns, DataGrid, GridCellParams } from '@material-ui/data-grid';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LayersIcon from '@material-ui/icons/Layers';
import { useStyles } from './styles';
import { Paper } from '@material-ui/core';
import PreviewIcon from '@material-ui/icons/RemoveRedEyeSharp';
import { orange } from '@material-ui/core/colors';
export const GroupsTable: FC = observer(() => {
  const history = useHistory();
  const classes = useStyles();
  const {
    ldapStore: { groupsView, getGroups, setClickedGroup, deleteGroup },
    notificationStore: { openNotification },
  } = useStore();

  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [appStatus, setAppStatus] = useState<boolean>(false);
  const getGroupsReq = useQuery('getGroupsReq', () => getGroups(), {
    onError: () => openNotification('error', `Can't get groups`),
  });

  const deleteGroupReq = useMutation((appStatus: boolean) => deleteGroup(appStatus), {
    mutationKey: 'deleteGroupReq',
    onSuccess: () => {
      openNotification('success', `Deleted succcessfully`);
      getGroupsReq.refetch();
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || 'Group cannot be deleted.';
      openNotification('error', errorMessage);
    },
  });

  useAppPreloader(getGroupsReq.isFetching || deleteGroupReq.isLoading);

  const columns: GridColumns = [
    {
      field: 'icon',
      headerName: ' ',
      width: 40,
      align: 'center',
      renderCell: (params: GridCellParams) => <LayersIcon />,
    },
    { field: 'cn', headerName: 'NAMEs', flex: 0.5 },
    { field: 'description', headerName: 'DESCRIPTION', flex: 1 },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      disableColumnMenu: true,
      align: 'center',
      width: 160,
      renderCell: (params: GridCellParams) => (
        <>
          <IconButton size='small' onClick={() => history.push('/group/view')}>
            <PreviewIcon style={{ color: orange[500] }} />
          </IconButton>
          <IconButton size='small' onClick={() => history.push('/group/edit')}>
            <EditIcon style={{ fill: '#FF9800' }} />
          </IconButton>
          <IconButton size='small' onClick={() => setOpenConfirmDialog(true)}>
            <DeleteIcon style={{ fill: '#F44336' }} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          checkboxSelection
          rows={!getGroupsReq.isFetching ? groupsView : []}
          columns={columns}
          onCellClick={(event: GridCellParams) => setClickedGroup(event.row.dn)}
        />
      </Paper>
      <ConfirmActionDialog
        label='Delete Group'
        appnotify={appStatus}
        gitStatus=''
        appnotifyStatus={setAppStatus}
        buttonLabel='Confirm'
        openModal={openConfirmDialog}
        action={() => deleteGroupReq.mutate(appStatus)}
        handleClose={() => {
          setOpenConfirmDialog(false);
          setAppStatus(true);
        }}
      />
    </>
  );
});
